import saly from '@/assets/images/icons/saly-26.png';

export const HowItWorksSteps = [
  {
    icon: saly,
    name: 'Etape 1: Sélectionner son point A et point B',
    children: ['step_1_description_1', 'step_1_description_2'],
  },
  {
    icon: saly,
    name: 'Etape 2: choisir sa distance',
    children: ['step_2_description_1'],
  },
  {
    icon: saly,
    name: 'Etape 3: hébergements, restaurants et activités',
    children: ['step_3_description_1', 'step_3_description_2'],
  },
  {
    icon: saly,
    name: 'Etape 4: Bien préparer son voyage à vélo',
    children: ['step_4_description_1'],
  },
  {
    icon: saly,
    name: 'Etape 5 (optionnelle): Louez votre vélo',
    children: ['step_5_description_1'],
  },
  {
    icon: saly,
    name: 'Etape 6 (indispensable): Profitez',
    children: ['step_6_description_1'],
  },
] as const;
